/* AP · Clean-Up Rank (Christmas Clean-Up private sale, 16-18/10/2026). Built 15/10, endpoints aligned 16/10 (plan 261015-1801, Phase 4).
 * Markup: sections/ap-cleanup-sale.liquid (clock, flash bar, rank strip, Last Chance count), snippets/ap-cleanup-rank.liquid
 * (#cuRank popup, #cuBoard sheet), sections/ap-cleanup-rules.liquid, snippets/ap-cleanup-cart-bar.liquid (<ap-cu-cartbar>).
 * App proxy (pdp-upsell-app, reports/phase-03-app-handoff.md section 4; points / gap are dollars):
 *   GET  /apps/afp-analytics/cleanup/leaderboard -> {ok, open, updatedAt, startsAt, endsAt, frozen, top:[{rank,name,place,points}],
 *        first:{points}|null, prizes:[{from,to,label}]}
 *   POST /apps/afp-analytics/cleanup/me {email} and GET .../me?sid=<Postscript s-id> -> {ok, points, tier|null, tierLabel,
 *        nextTier|null, nextTierLabel, gap|null, rank|null, unlocked, tiers, endsAt, frozen}
 *   errors {ok:false, error:'bad_input'|'too_many'|'unknown_sid'|'busy'|'off', message} (message shown as is).
 *   GET  /apps/afp-analytics/cleanup/lc -> {ok, left, soldOut, weekendLeft, weekendCap, startsAt, endsAt} (hero counter, every 45 s).
 *   /me is cached 60 s per visitor (one call per page view at most); 'off' or no app -> static tiers stay.
 * Preview: ?cu_mock=1 (Silver + live board) | gold | 2 (Queen + final board) | empty (unknown visitor, empty board) | off;
 *   with a mock, &cu_now=<ISO> fakes the clock, &cu_day=d2|d3 shows another day's note, &cu_lc=37|out previews the Last Chance count
 *   (and today's count on the hero counter), &cu_wl=<n> the counter's weekend total.
 * Storage (all in try/catch; the page works without it): ap_cu_sid, ap_cu_email, ap_cu_me {at, who, d}, ap_cu_nosid.
 */
(function () {
  'use strict';
  if (window.__apCuRank) return;
  window.__apCuRank = 1;

  var P = new URLSearchParams(location.search);
  var MOCK = P.get('cu_mock') || '';
  var root = document.querySelector('[data-cu-root]');
  var API = (root && root.getAttribute('data-api')) || '/apps/afp-analytics/cleanup';
  var AMT = ((root && root.getAttribute('data-tiers')) || '100,150,200').split(',').map(Number);
  var KEYS = ['silver', 'gold', 'queen'];
  var NAME = { silver: 'Silver', gold: 'Gold', queen: 'Queen' };
  var GIFT = { silver: 'free matching leggings', gold: 'a free dress of your choice', queen: 'a free winter piece of your choice: a hoodie dress, sweatshirt or cardigan' };
  var START = Date.parse((root && root.getAttribute('data-start')) || '2026-10-16T08:00:00-07:00');
  var SID_RE = /^[A-Za-z0-9_-]{1,64}$/, EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var REFRESH = 5 * 60 * 1000, ME_TTL = 60 * 1000;
  var OFF_MSG = 'The Clean-Up Rank is not open right now.';
  var html = document.documentElement;
  var fakeNow = MOCK ? Date.parse(P.get('cu_now') || '') : NaN;
  var t0 = Date.now();
  function now() { return isNaN(fakeNow) ? Date.now() : fakeNow + (Date.now() - t0); }

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function money(x) { x = Math.round((Number(x) || 0) * 100) / 100; return '$' + (x % 1 ? x.toFixed(2) : x.toLocaleString('en-US')); }
  function tierOf(p) { var t = 'none'; for (var i = 0; i < 3; i++) if (p >= AMT[i]) t = KEYS[i]; return t; }
  function nextOf(p) { for (var i = 0; i < 3; i++) if (p < AMT[i]) return { key: KEYS[i], amt: AMT[i] }; return null; }
  function pct(p) { return Math.min(100, p / AMT[2] * 100).toFixed(1) + '%'; }
  function fail(d) { var e = new Error((d && d.error) || 'busy'); e.code = (d && d.error) || 'busy'; e.msg = (d && d.message) || ''; return e; }

  // ---- who is this visitor: a fresh s-id in the link wins, then a remembered email, then a remembered s-id ----
  var sid = (P.get('s-id') || P.get('sid') || '').trim(), urlSid = SID_RE.test(sid);
  if (urlSid) { if (!MOCK) ls('ap_cu_sid', sid); }
  else { sid = ls('ap_cu_sid') || ls('ap_tarot_sid') || ''; if (!SID_RE.test(sid) || sid === ls('ap_cu_nosid')) sid = ''; }
  var email = urlSid ? '' : (ls('ap_cu_email') || '');
  if (!EMAIL_RE.test(email)) email = '';
  var off = MOCK === 'off';
  function known() { return MOCK ? MOCK !== 'empty' && MOCK !== 'off' : !!(sid || email); }
  function who() { return email ? 'e:' + email : sid ? 's:' + sid : ''; }

  // Tier, next tier and gap come from the points and this page's thresholds (data-tiers), so every number on the page agrees
  // even if the app's tier config lags; the app's points and rank are used as given.
  function norm(d) {
    var p = Math.max(0, Number(d.points) || 0), nx = nextOf(p);
    return { points: p, tier: tierOf(p), next: nx ? nx.key : null, gap: nx ? Math.round((nx.amt - p) * 100) / 100 : 0, rank: Number(d.rank) > 0 ? Number(d.rank) : null };
  }
  function readCache() {
    try { var c = JSON.parse(ls('ap_cu_me') || 'null'); return c && c.d && c.who === who() && Date.now() - c.at < 3 * 86400000 ? c : null; } catch (e) { return null; }
  }
  function cached() {
    if (MOCK) return known() ? norm(mockMe()) : null;
    var c = known() && readCache(); return c ? c.d : null;
  }
  function mockMe() {
    var T = { '1': [112.5, 'silver', 'gold', 37.5, 41], gold: [165, 'gold', 'queen', 35, 16], '2': [268.4, 'queen', null, null, 7] }[MOCK] || [0, null, 'silver', 100, null];
    return { ok: true, points: T[0], tier: T[1], tierLabel: T[1] ? NAME[T[1]] : null, nextTier: T[2], nextTierLabel: T[2] ? NAME[T[2]] : null, gap: T[3], rank: T[4],
      unlocked: [], endsAt: '2026-10-19T07:00:00.000Z', frozen: MOCK === '2' };
  }
  function getJSON(url, opt) {
    return fetch(url, opt || { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: r.status === 404 ? 'off' : 'busy' }; }); });
  }
  // em = an email typed in the popup (always asks the app); otherwise the remembered email or s-id, cached ME_TTL.
  function getMe(em) {
    if (!em) { var c = !MOCK && readCache(); if (c && Date.now() - c.at < ME_TTL) return Promise.resolve(c.d); }
    var p = MOCK ? new Promise(function (ok) { setTimeout(function () { ok(off ? { ok: false, error: 'off', message: OFF_MSG } : mockMe()); }, 300); })
      : (em || email) ? getJSON(API + '/me', { method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ email: em || email }) })
        : getJSON(API + '/me?sid=' + encodeURIComponent(sid));
    return p.then(function (d) {
      if (!d || d.ok !== true) {
        var e = fail(d);
        if (e.code === 'off') { off = true; paintStrip(null); }
        if (e.code === 'unknown_sid' && !em) { ls('ap_cu_nosid', sid); if (ls('ap_cu_sid') === sid) ls('ap_cu_sid', null); sid = ''; paintStrip(null); }
        throw e;
      }
      var m = norm(d);
      if (em && !MOCK) { email = em; ls('ap_cu_email', em); }
      if (!MOCK) ls('ap_cu_me', JSON.stringify({ at: Date.now(), who: who(), d: m }));
      return m;
    });
  }

  // ---- rank strip on the sale page ----
  var strip = $('[data-cu-strip]');
  function paintStrip(m) {
    if (!strip) return;
    var box = $('[data-cu-me]', strip);
    $$('[data-tier]', strip).forEach(function (t, i) {
      var on = !!m && m.points >= AMT[i];
      t.classList.toggle('is-on', on);
      $('[data-cu-ok]', t).hidden = !on;
    });
    var b = $('[data-cu-open="rank"]', strip);
    if (!m) { box.hidden = true; if (b) b.textContent = b.getAttribute('data-label') || b.textContent; return; }
    box.hidden = false;
    $('[data-cu-me-t]', box).textContent = money(m.points) + ' so far' + (m.tier !== 'none' ? ' · ' + NAME[m.tier] + ' unlocked' : '') + (m.rank && m.rank <= 20 ? ' · #' + m.rank : '');
    $('[data-cu-me-bar]', box).style.width = pct(m.points);
    $('[data-cu-me-n]', box).textContent = m.next ? money(m.gap) + ' more to ' + NAME[m.next] + ': ' + GIFT[m.next] + '.' : 'Queen reached. Every gift is yours.';
    if (b) { if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent); b.textContent = 'See my rank'; }
  }

  // ---- dialogs (popup + sheet): moved to <body> so no page transform / overflow can clip them ----
  var dlgs = {};
  ['cuRank', 'cuBoard'].forEach(function (id) { var d = document.getElementById(id); if (d) { document.body.appendChild(d); dlgs[id] = d; } });
  var openD = null, lastFocus = null;
  function focusables(box) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.offsetWidth || x.offsetHeight; });
  }
  function openDlg(id, focusEl) {
    var d = dlgs[id]; if (!d) return false;
    if (openD && openD !== d) { openD.hidden = true; } else if (!openD) lastFocus = document.activeElement;
    d.hidden = false; openD = d; html.classList.add('cu-lock');
    (focusEl || $('[role="dialog"]', d)).focus({ preventScroll: true });
    if (id === 'cuBoard') boardOpened();
    return true;
  }
  function closeDlg() {
    if (!openD) return;
    openD.hidden = true; openD = null; html.classList.remove('cu-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    var o = t.closest('[data-cu-open]'), a = t.closest('a[href^="#cu-"]');
    var which = o ? o.getAttribute('data-cu-open') : a ? a.getAttribute('href').slice(4) : '';
    if (which === 'rank' || which === 'board') { e.preventDefault(); which === 'rank' ? openRank() : openDlg('cuBoard'); return; }
    if (t.closest('[data-cu-close]')) closeDlg();
  });
  document.addEventListener('keydown', function (e) {
    if (!openD) return;
    if (e.key === 'Escape') { closeDlg(); return; }
    if (e.key !== 'Tab') return;
    var box = $('[role="dialog"]', openD), f = focusables(box);
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1], cur = document.activeElement;
    if (e.shiftKey && (cur === a || cur === box)) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && (cur === z || !box.contains(cur))) { e.preventDefault(); a.focus(); }
  });

  // ---- popup: email lookup ----
  var R = dlgs.cuRank;
  var form = R && $('[data-cu-form]', R), res = R && $('[data-cu-res]', R), msg = R && $('[data-cu-msg]', R);
  var input = form && $('input[name="email"]', form), btn = form && $('[data-cu-submit]', form);
  function say(t) { if (!msg) return; msg.textContent = t || ''; msg.hidden = !t; }
  function showForm(t) { form.hidden = false; res.hidden = true; say(t || ''); }
  function errText(e) {
    if (e.msg) return e.msg;
    if (e.code === 'off') return now() < START ? 'Gift totals start counting at 8 AM on Friday. Check back then.' : OFF_MSG;
    return now() < START ? 'Gift totals start counting at 8 AM on Friday. Check back then.' : 'Something hiccupped. Try again in a moment.';
  }
  function paintRes(m) {
    form.hidden = true; res.hidden = false;
    $('[data-cu-r-total]', res).textContent = money(m.points);
    $('[data-cu-r-tier]', res).textContent = m.tier !== 'none' ? NAME[m.tier] + ' unlocked' : (m.points > 0 ? 'Almost at Silver' : 'Your total starts with your first sale order');
    $('[data-cu-r-bar]', res).style.width = pct(m.points);
    var ol = $('[data-cu-r-steps]', res); ol.textContent = '';
    KEYS.forEach(function (k, i) {
      var on = m.points >= AMT[i], li = el('li', on ? 'is-on' : '');
      li.appendChild(el('b', null, money(AMT[i]) + ' ' + NAME[k]));
      li.appendChild(el('span', null, (on ? 'Unlocked: ' : '') + GIFT[k]));
      ol.appendChild(li);
    });
    $('[data-cu-r-next]', res).textContent = m.next ? money(m.gap) + ' more unlocks ' + NAME[m.next] + ': ' + GIFT[m.next] + '.' : 'Queen reached. Every gift is yours.';
    var rk = $('[data-cu-r-rank]', res);
    rk.hidden = !m.rank;
    rk.textContent = m.rank ? 'You are #' + m.rank + ' on the leaderboard' + (m.rank <= 20 ? ' and in the prizes.' : '.') + (board && board.first ? ' #1 is at ' + money(board.first) + '.' : '') : '';
    $('[data-cu-swap]', res).hidden = MOCK ? false : !email;
  }
  function openRank() {
    if (!R) return;
    var c = cached();
    if (known() && !off) {
      if (c) paintRes(c); else showForm('Looking up your total…');
      openDlg('cuRank', c ? null : input);
      getMe('').then(function (m) { paintRes(m); paintStrip(m); }, function (e) { if (!c || e.code === 'unknown_sid' || e.code === 'off') showForm(errText(e)); });
      return;
    }
    showForm(off ? errText({ code: 'off' }) : '');
    openDlg('cuRank', input);
  }
  if (form) {
    if (email) input.value = email;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = String(input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(v)) { say('Check your email and try again.'); input.focus(); return; }
      say(''); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      getMe(v).then(function (m) {
        paintRes(m); paintStrip(m);
        $('[role="dialog"]', R).focus({ preventScroll: true });
      }, function (err) { say(errText(err)); })
        .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
    });
    $('[data-cu-swap]', R).addEventListener('click', function () {
      email = ''; ls('ap_cu_email', null); ls('ap_cu_me', null); input.value = '';
      paintStrip(null); showForm(); input.focus();
    });
  }

  // ---- leaderboard sheet ----
  var B = dlgs.cuBoard, board = null, boardAt = 0, boardTimer = null;
  function mockBoard() {
    if (off) return { ok: false, error: 'off', message: OFF_MSG };
    var top = [], names = ['Gloria B.', 'Tasha T.', 'Denise H.', 'Lorraine M.', 'Karen K.', 'Monique W.', 'Guest', 'Sharon D.', 'Angela P.', 'Yvette C.'];
    var places = ['GA', 'TX', 'MD', 'IL', 'NC', 'CA', 'TN', 'OH', 'NJ', 'FL'];
    for (var i = 1; i <= (MOCK === 'empty' ? 0 : 20); i++) top.push({ rank: i, name: names[(i - 1) % 10], place: names[(i - 1) % 10] === 'Guest' ? '' : places[(i * 3) % 10], points: Math.round((612 - (i - 1) * 21.4) * 100) / 100 });
    return { ok: true, open: now() >= START, updatedAt: new Date(now() - 3 * 60000).toISOString(), startsAt: '2026-10-16T15:00:00.000Z', endsAt: '2026-10-19T07:00:00.000Z',
      frozen: MOCK === '2', top: top, first: top[0] ? { points: top[0].points } : null,
      prizes: [{ from: 1, to: 1, label: 'The whole weekend back, up to $500 + the Winter Wardrobe' },
        { from: 2, to: 3, label: 'The Winter Wardrobe: 2 hoodie dresses, 2 matching leggings, a cardigan, a sweatshirt and a tumbler' },
        { from: 4, to: 10, label: 'A hoodie dress + matching leggings + a tumbler' }, { from: 11, to: 20, label: 'A matching tumbler' }] };
  }
  function boardState(text) { var l = $('[data-cu-b-list]', B); l.textContent = ''; l.appendChild(el('li', 'cuB__state', text)); }
  function boardOpened() { if (now() - boardAt > 60000 || !board) loadBoard(); if (!boardTimer) boardTimer = setInterval(function () { if (openD === B && !document.hidden) loadBoard(); }, REFRESH); }
  function loadBoard() {
    boardAt = now();
    (MOCK ? Promise.resolve(mockBoard()) : getJSON(API + '/leaderboard')).then(function (d) {
      if (!d || d.ok !== true || !Array.isArray(d.top)) throw fail(d);
      paintBoard(d);
    }).catch(function (e) {
      if (!board) boardState(e && e.msg ? e.msg : now() < START ? 'The board opens at 8 AM on Friday.' : 'The board is refreshing. Check back in a few minutes.');
      else $('[data-cu-b-upd]', B).textContent = 'Could not refresh just now. Trying again shortly.';
    });
  }
  function paintBoard(d) {
    var top = d.top.filter(function (r) { return Number(r.rank) <= 20; }).sort(function (a, b) { return a.rank - b.rank; });
    var first = (d.first && Number(d.first.points)) || 0;
    board = { first: first };
    if (Array.isArray(d.prizes) && d.prizes.length) {
      var ul = $('.cuB__ladder', B); ul.textContent = '';
      d.prizes.forEach(function (p) { var li = el('li'); li.appendChild(el('b', null, '#' + p.from + (p.to > p.from ? '–' + p.to : ''))); li.appendChild(el('span', null, p.label || '')); ul.appendChild(li); });
    }
    $('[data-cu-b-state]', B).textContent = d.frozen ? 'Final standings' : 'Live leaderboard';
    $('[data-cu-b-first]', B).textContent = first ? '#1 is at ' + money(first) + '. #1 gets the whole weekend back, up to $500.' : '#1 could be you. #1 gets the whole weekend back, up to $500.';
    var me = cached(), mb = $('[data-cu-b-me]', B);
    // Owner 17/10 ~01:00 VN: her cached rank comes from her last "See my total" lookup and goes stale as the
    // board moves (she saw "You: $69.97 · #9" while the live #9 held $134.93, and the wrong row glowed).
    // Trust the cached rank only while the live board agrees with it; otherwise show her points alone.
    if (me && me.rank) {
      var meRow = top.filter(function (r) { return Number(r.rank) === Number(me.rank); })[0];
      if (!meRow || Math.abs(Number(meRow.points) - Number(me.points)) > 0.005) me = { points: me.points, rank: null };
    }
    mb.hidden = !me; mb.textContent = '';
    if (me) {
      mb.appendChild(el('span', null, 'You: ' + money(me.points) + (me.rank ? ' · #' + me.rank : '')));
      var n20 = top[19] && Number(top[19].points);
      if (!d.frozen && n20 && (!me.rank || me.rank > 20)) mb.appendChild(el('span', null, '#20 is at ' + money(n20)));
    }
    var l = $('[data-cu-b-list]', B); l.textContent = '';
    if (!top.length) boardState(d.open === false ? 'The board opens at 8 AM on Friday.' : 'The board fills in as orders come in.');
    // Owner 16/10 (~23:50 VN): the full top-20 list is too long. Show #1-3, a gap row, and the last
    // entry only; the viewer's own row stays visible wherever she sits. 5 entries or fewer: show all.
    var showAll = top.length <= 5, keep = {}, prev = null;
    top.forEach(function (r, i) { if (showAll || Number(r.rank) <= 3 || i === top.length - 1 || (me && me.rank === Number(r.rank))) keep[i] = true; });
    top.forEach(function (r, i) {
      if (!keep[i]) return;
      if (prev !== null && i - prev > 1) { var gap = el('li', 'cuB__gap'); gap.style.justifyContent = 'center'; gap.appendChild(el('span', 'n', '· · ·')); l.appendChild(gap); }
      prev = i;
      var li = el('li', (r.rank <= 3 ? 'top3' : '') + (me && me.rank === Number(r.rank) ? ' is-me' : ''));
      li.appendChild(el('span', 'r', '#' + r.rank));
      var n = el('span', 'n'); n.appendChild(el('b', null, r.name || 'Guest')); if (r.place) n.appendChild(el('small', null, r.place));
      li.appendChild(n); li.appendChild(el('span', 'p', money(r.points)));
      l.appendChild(li);
    });
    var u = new Date(d.updatedAt), t = isNaN(u) ? '' : u.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    $('[data-cu-b-upd]', B).textContent = d.frozen ? 'Final standings. Winners hear from us after the Monday check.' : (t ? 'Updated ' + t + ' · ' : '') + 'refreshes every 5 minutes';
    if (d.frozen && boardTimer) { clearInterval(boardTimer); boardTimer = null; }
  }

  // ---- clocks: hero "ends in" + flash slots ----
  function two(n) { return n < 10 ? '0' + n : '' + n; }
  var count = $('[data-cu-count]'), flashes = $('[data-cu-flashes]');
  // the short intro has the hero counter (data-cu-slots) instead of the clock; it carries the same start / end for the time bar
  var clk = count || $('[data-cu-slots]');
  var cEnd = clk ? Date.parse(clk.getAttribute('data-end')) : NaN, cStart = clk ? Date.parse(clk.getAttribute('data-start')) : NaN;
  var slots = flashes ? $$('[data-cu-flash]', flashes).map(function (a) { return { a: a, s: Date.parse(a.getAttribute('data-s')), e: Date.parse(a.getAttribute('data-e')), left: $('[data-cu-left]', a) }; }) : [];
  // "Today's prices end at midnight": 23:59:59 of the current sale day, in the offset written on end_at (e.g. -07:00)
  var mid = $('[data-cu-mid]'), midLeft = mid && $('[data-cu-mid-left]', mid);
  var offM = /([+-])(\d{2}):?(\d{2})$/.exec(clk ? clk.getAttribute('data-end') || '' : ''), OFF = offM ? (offM[1] === '-' ? -1 : 1) * (+offM[2] * 60 + +offM[3]) * 60000 : -7 * 3600000;
  function midnight(t) { var w = new Date(t + OFF); return Date.UTC(w.getUTCFullYear(), w.getUTCMonth(), w.getUTCDate(), 23, 59, 59) - OFF; }
  var tbar = $('[data-cu-tbar]'), tbarT = tbar && $('[data-cu-tbar-t]', tbar), tbarF = tbar && $('[data-cu-tbar-fill]', tbar);
  var DOORS_GAP = !isNaN(cStart) ? midnight(cStart) - cStart : 0; // doors (08:00 Fri) -> 23:59:59 on the doors day, the daily price window
  function tick() {
    var t = now();
    if (tbar) {
      if ((!isNaN(cStart) && t < cStart) || (!isNaN(cEnd) && t >= cEnd)) tbar.hidden = true;
      else {
        var tm = Math.min(midnight(t), cEnd), tl = Math.max(0, tm - t), win = DOORS_GAP || 15 * 3600000;
        var hh = Math.floor(tl / 3600000), mmm = Math.floor(tl % 3600000 / 60000), txt = hh + 'h ' + two(mmm) + 'm';
        tbarT.textContent = (tbar.getAttribute(midnight(t) >= cEnd - 1000 ? 'data-final' : 'data-label') || '').replace('{time}', txt);
        tbarF.style.width = (Math.min(1, tl / win) * 100).toFixed(1) + '%';
        tbar.hidden = false;
      }
    }
    if (midLeft) {
      var ml = Math.floor((midnight(t) - t) / 1000);
      if ((!isNaN(cEnd) && t >= cEnd) || (!isNaN(cStart) && t < cStart)) mid.hidden = true;
      else midLeft.textContent = Math.floor(ml / 3600) + ':' + two(Math.floor(ml % 3600 / 60)) + ':' + two(ml % 60);
    }
    if (count && !isNaN(cEnd)) {
      var pre = !isNaN(cStart) && t < cStart, ms = (pre ? cStart : cEnd) - t, lab = $('[data-cu-count-l]', count), units = $('[data-cu-units]', count);
      // short intro: on sale days the clock counts to midnight today (the last day's midnight is the end of the sale)
      var midMode = !pre && count.hasAttribute('data-midnight'), dUnit = $('[data-cu-dunit]', count);
      if (midMode) { var mn = midnight(t); ms = Math.min(mn, cEnd) - t; }
      if (dUnit) dUnit.hidden = midMode;
      if (ms <= 0 && !pre) { lab.textContent = lab.getAttribute('data-done'); units.hidden = true; count.classList.add('is-done'); }
      else if (midMode) {
        lab.textContent = count.getAttribute(midnight(t) >= cEnd - 1000 ? 'data-final' : 'data-mid');
        var sm = Math.floor(ms / 1000), vm = { h: Math.floor(sm / 3600), m: Math.floor(sm % 3600 / 60), s: sm % 60 };
        $$('[data-u]', count).forEach(function (b) { var k = b.getAttribute('data-u'); if (k !== 'd') b.textContent = two(vm[k]); });
      }
      else {
        lab.textContent = lab.getAttribute(pre ? 'data-pre' : 'data-live');
        var s = Math.floor(ms / 1000), v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        $$('[data-u]', count).forEach(function (b) { b.textContent = two(v[b.getAttribute('data-u')]); });
      }
    }
    if (slots.length) {
      var any = false;
      slots.forEach(function (x) {
        var live = t >= x.s && t < x.e; x.a.hidden = !live; any = any || live;
        if (live) { var s = Math.floor((x.e - t) / 1000); x.left.textContent = Math.floor(s / 3600) + ':' + two(Math.floor(s % 3600 / 60)) + ':' + two(s % 60); }
      });
      flashes.hidden = !any;
    }
  }
  if (count || slots.length || midLeft || tbar) { tick(); setInterval(tick, 1000); }

  // the day's note / banners follow the clock from each day's doors (9 AM Sat = d2, 9 AM Sun = d3), so nothing has to
  // flip the section's `day` setting at 9 AM and a cached page still turns over; &cu_day=… previews a day (mock only).
  // Tab chips with windows stay hidden outside them: Christmas / Sunday Best until their debut day (the blocks are enabled
  // in the template), Flash Deal outside the flash slots (owner 16/10, Fri PT: corset 08:50-10:00, sweetheart 10:20-11:30,
  // hoodie 14:50-17:00, leggings 16:20-18:30; Sat 17/10 PT price flashes: new sweetheart 08:50-10:00, cardigans &
  // sweatshirts 11:50-13:00, long sleeve maxi 16:20-17:30; Saturday slots without a price change get no window). Checked
  // at load and every 30 s. A key here HIDES its chip outside its windows, so only gated chips belong here, never a line
  // tab (cu-line-sweetheart, cu-winter ...). The flash banners are not driven by this list: they are the flash blocks of
  // sections/ap-cleanup-sale.liquid (own start / end / tag), which carry the same Saturday windows.
  var DAY_AT = [['d3', Date.parse('2026-10-18T08:00:00-07:00')], ['d2', Date.parse('2026-10-17T03:15:00-07:00')]]; // d3 at the 08:00 PT doors (owner 18/10)
  var win = function (a, b) { return [Date.parse(a), Date.parse(b)]; };
  var TAB_WIN = { 'cu-christmas': [[DAY_AT[1][1], Infinity]], 'cu-sunday-best': [[DAY_AT[0][1], Infinity]],
    'cu-leaving': [[0, Date.parse('2026-10-18T07:51:00-07:00')], [Date.parse('2026-10-18T08:40:00-07:00'), Infinity]], // Sun 18/10: batch 2 DRAFT at the doors, batch 3 ("Leaving the Store") tagged early at 08:40 PT (owner 22:40 VN)
    'cu-flash': [win('2026-10-16T08:50:00-07:00', '2026-10-16T10:00:00-07:00'), win('2026-10-16T10:20:00-07:00', '2026-10-16T11:30:00-07:00'),
      win('2026-10-16T14:50:00-07:00', '2026-10-16T17:00:00-07:00'), win('2026-10-16T16:20:00-07:00', '2026-10-16T18:30:00-07:00'),
      win('2026-10-17T08:50:00-07:00', '2026-10-17T10:00:00-07:00'), win('2026-10-17T11:50:00-07:00', '2026-10-17T13:00:00-07:00'),
      win('2026-10-17T16:20:00-07:00', '2026-10-17T17:30:00-07:00'), win('2026-10-18T08:50:00-07:00', '2026-10-18T10:00:00-07:00'), win('2026-10-18T13:20:00-07:00', '2026-10-18T14:30:00-07:00'), win('2026-10-18T14:50:00-07:00', '2026-10-18T16:00:00-07:00'), win('2026-10-18T16:23:00-07:00', '2026-10-18T17:45:00-07:00')] }; // Sun 18/10 windows + final hour (Lena's Picks tab)
  var pday = MOCK && P.get('cu_day'), cuSale = $('#cuSale');
  if (!pday && cuSale) {
    for (var di = 0; di < DAY_AT.length; di++) if (now() >= DAY_AT[di][1]) { pday = DAY_AT[di][0]; break; }
    if (pday === cuSale.getAttribute('data-day')) pday = null;
  }
  function tabWindows() {
    $$('.ap-ctabs__chip').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split('?')[0], w = TAB_WIN[h.slice(h.lastIndexOf('/') + 1)];
      if (w) a.style.display = w.some(function (x) { return now() >= x[0] && now() < x[1]; }) ? '' : 'none';
    });
  }
  tabWindows(); setInterval(tabWindows, 30000);
  if (pday) {
    $$('[data-cu-day]').forEach(function (n) { n.hidden = n.getAttribute('data-cu-day') !== pday; });
    $$('[data-cu-days]').forEach(function (n) { n.hidden = n.getAttribute('data-cu-days').split(',').indexOf(pday) < 0; });
  }

  // ---- hero counter (owner 16/10 18:50 VN): "300 -> 0" $14.99 dresses left this weekend, in place of the short intro's clock ----
  // Markup [data-cu-slots] in sections/ap-cleanup-sale.liquid; server values from shop metafields cleanup.lc_weekend_left (300 while
  // blank), cleanup.lc_left, cleanup.lc_sold_out. Polls GET <API>/lc {ok, day, cap, sold, left, soldOut, weekendLeft, weekendCap, startsAt, endsAt}
  // on load and every 45 s while the tab is visible; only ok === true is used, anything else (404 before the app ships) keeps the
  // server values. Line: before doors -> pre; sale over or 0 left -> done (number 0); today's batch gone -> out (out-am after
  // midnight before a 9 AM batch, out-last after Sunday's batch); else open ({n} = left today, the "· {n} ..." part drops when
  // unknown). The number counts down over ~600 ms and never goes below 0. Mock: &cu_lc=37|out, &cu_wl=<n> (no poll).
  var ctr = $('[data-cu-slots]');
  if (ctr) (function () {
    var nEl = $('[data-cu-slots-n]', ctr), sub = $('[data-cu-slots-sub]', ctr), goal = $('[data-cu-goal]', ctr);
    var goalFill = goal && $('[data-cu-goal-fill]', goal), goalT = goal && $('[data-cu-goal-t]', goal), goalN = goal ? (parseInt(goal.getAttribute('data-goal'), 10) || 300) : 300;
    var int = function (x) { var n = parseInt(x, 10); return isNaN(n) ? null : n; };
    var v = { wl: int(ctr.getAttribute('data-wl')), left: int(ctr.getAttribute('data-left')), sold: ctr.getAttribute('data-sold') === '1' };
    if (v.wl === null) v.wl = 300;
    var shown = int(nEl && nEl.textContent), raf = 0, st = '', polled = 0;
    if (shown === null) shown = v.wl;
    var mLc = MOCK ? P.get('cu_lc') || '' : '', mWl = MOCK ? int(P.get('cu_wl')) : null;
    if (mLc === 'out') { v.left = 0; v.sold = true; } else if (int(mLc) !== null) { v.left = int(mLc); v.sold = v.left <= 0; }
    if (mWl !== null) v.wl = mWl;
    var mocked = !!mLc || mWl !== null;
    function lineFor(k) {
      if (k === 'open') {
        var tpl = ctr.getAttribute('data-open') || '';
        if (v.left !== null) return tpl.replace('{n}', Math.max(0, v.left));
        return tpl.split('·').filter(function (p) { return p.indexOf('{n}') < 0; }).map(function (p) { return p.trim(); }).filter(Boolean).join(' · ');
      }
      return ctr.getAttribute('data-' + k) || (k.indexOf('out') === 0 ? ctr.getAttribute('data-out') : '') || '';
    }
    function stateAt(t) {
      if (!isNaN(cStart) && t < cStart) return 'pre';
      if ((!isNaN(cEnd) && t >= cEnd) || v.wl <= 0) return 'done';
      if (!v.sold && (v.left === null || v.left > 0)) return 'open';
      if (t >= DAY_AT[0][1]) return 'out-last';
      for (var i = 0; i < DAY_AT.length; i++) if (t < DAY_AT[i][1] && t >= DAY_AT[i][1] - 9 * 3600000) return 'out-am';
      return 'out';
    }
    function countTo(to) {
      to = Math.max(0, Math.round(to));
      if (!nEl || to === shown) return;
      var from = shown, t0 = 0; shown = to;
      if (raf && window.cancelAnimationFrame) cancelAnimationFrame(raf);
      raf = 0;
      if (!window.requestAnimationFrame || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { nEl.textContent = to; return; }
      raf = requestAnimationFrame(function step(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 600), e = 1 - Math.pow(1 - k, 3);
        nEl.textContent = Math.max(0, Math.round(from + (to - from) * e));
        raf = k < 1 ? requestAnimationFrame(step) : 0;
      });
    }
    function render() {
      var k = stateAt(now()), line = lineFor(k);
      if (k !== st) { st = k; ctr.setAttribute('data-state', k); }
      if (sub) { if (sub.textContent !== line) sub.textContent = line; sub.hidden = !line; }
      countTo(k === 'done' ? 0 : v.wl);
    }
    function poll() {
      if (mocked || !window.fetch || (document.visibilityState && document.visibilityState !== 'visible')) return;
      polled = Date.now();
      fetch(API + '/lc', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || d.ok !== true) return;
          var wl = int(d.weekendLeft);
          if (wl !== null) v.wl = Math.max(0, wl);
          // day: null = no batch running (before doors, between days): its left 0 is not "sold out", so today's count is unknown
          if ('left' in d) v.left = d.day === null || d.left === null ? null : int(d.left);
          if (typeof d.soldOut === 'boolean') v.sold = d.soldOut;
          // goal bar: real orders placed today vs the day's goal (a goal, never a cap); shown once the app answers
          var o = int(d.ordersToday), g = int(d.ordersGoal) || goalN;
          if (goal && o !== null) {
            var hit = o >= g, tpl = goal.getAttribute(hit ? 'data-done' : 'data-tpl') || (hit ? '{n} / {goal} · goal smashed' : '{n} / {goal} orders today');
            if (goalT) goalT.textContent = tpl.replace('{n}', o.toLocaleString('en-US')).replace('{goal}', g.toLocaleString('en-US'));
            if (goalFill) goalFill.style.width = Math.min(100, Math.round(o / g * 1000) / 10) + '%';
            goal.classList.toggle('is-hit', hit);
            goal.hidden = false;
          }
          render();
        })
        .catch(function () {});
    }
    render(); setInterval(render, 1000);
    poll(); setInterval(poll, 45000);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && Date.now() - polled > 45000) poll(); });
  })();

  // the store chat bubble steps aside while the rank strip is on screen (owner 16/10: it covered the Queen card)
  if (strip && window.IntersectionObserver) new IntersectionObserver(function (es) { html.classList.toggle('cu-strip-in', es[0].isIntersecting); }, { threshold: 0.15 }).observe(strip);
  // short intro: the chat button (bottom-left on this page) steps aside while the intro card is behind it (the bottom 96px band)
  var intro = $('.cuS__intro');
  if (intro && window.IntersectionObserver) new IntersectionObserver(function (es) { html.classList.toggle('cu-strip-in', es[0].isIntersecting); },
    { rootMargin: '-' + Math.max(0, innerHeight - 96) + 'px 0px 0px 0px' }).observe(intro);

  // Last Chance count on the tab rail chip (sections/ap-collection-tabs renders the rail; the text comes from the shop metafields)
  var sale = $('#cuSale'), lcTag = sale && sale.getAttribute('data-lc-tag'), lcPrev = MOCK && P.get('cu_lc');
  if (lcTag && lcPrev) { // preview the count without the metafield: &cu_lc=37 | out (mock only), same rules as the Liquid
    try {
      var F = JSON.parse(sale.getAttribute('data-lc-fmt')), n = parseInt(lcPrev, 10), st = lcPrev === 'out' || n <= 0 ? 'out' : n < F.below ? 'few' : 'many';
      var tx = st === 'few' ? F.few.replace('{n}', n) : F[st], px = st === 'few' ? F.pfew.replace('{n}', n) : F['p' + st];
      sale.setAttribute('data-lc-pill', px); sale.setAttribute('data-lc-state', st);
      $$('.cuLcPill', sale).forEach(function (p) { p.textContent = px; p.className = 'cuLcPill cuLcPill--' + st; });
      $$('[data-cu-lc-text]', sale).forEach(function (p) { p.textContent = tx; });
      if (st === 'out') $$('[data-soldout]', sale).forEach(function (b) { b.textContent = b.getAttribute('data-soldout'); });
      var db = $('.cuS__db', sale), hd = $('.cuS__lc', sale); if (db) db.className = 'cuS__db cuS__db--' + st; if (hd) hd.className = 'cuS__lc cuS__lc--' + st;
    } catch (e) {}
  }
  if (lcTag) $$('.ap-ctabs__chip').forEach(function (a) {
    var h = (a.getAttribute('href') || '').split('?')[0];
    if (h.slice(-(lcTag.length + 1)) === '/' + lcTag && !$('.cuLcPill', a)) a.appendChild(el('span', 'cuLcPill cuLcPill--' + sale.getAttribute('data-lc-state'), sale.getAttribute('data-lc-pill')));
  });

  // ---- start ----
  var c0 = cached();
  if (c0) paintStrip(c0);
  if (strip && known() && !off) getMe('').then(paintStrip, function () {});
  var want = (P.get('cu_open') || location.hash.replace('#cu-', '')).toLowerCase();
  if (want === 'rank' && R) openRank(); else if (want === 'board' && B) openDlg('cuBoard');

  // ---- cart drawer bar: <ap-cu-cartbar data-cart="cents"> (snippets/ap-cleanup-cart-bar.liquid) ----
  // The server renders the cart-only message; this adds the visitor's earlier weekend total when we know it (no app call here).
  if (window.customElements && !customElements.get('ap-cu-cartbar')) {
    customElements.define('ap-cu-cartbar', class extends HTMLElement {
      static get observedAttributes() { return ['data-cart']; }
      connectedCallback() { this.paint(); }
      attributeChangedCallback() { if (this.isConnected) this.paint(); }
      paint() {
        var m = cached(); if (!m) return;
        var c = (Number(this.getAttribute('data-cart')) || 0) / 100, tot = m.points + c, nx = nextOf(tot), hit = tierOf(tot);
        var t1 = this.querySelector('[data-cu-c1]'), t2 = this.querySelector('[data-cu-c2]'), bar = this.querySelector('[data-cu-cbar]');
        if (t1) t1.textContent = 'This cart: ' + money(c) + ' · Your weekend so far: ' + money(m.points);
        if (t2) t2.textContent = hit !== m.tier && hit !== 'none' ? 'This cart unlocks ' + NAME[hit] + ': ' + GIFT[hit] + '.' + (nx ? ' Then ' + money(nx.amt - tot) + ' more to ' + NAME[nx.key] + '.' : '')
          : nx ? money(nx.amt - tot) + ' more to ' + NAME[nx.key] + ': ' + GIFT[nx.key] + '.' : 'Queen reached. Every gift is yours.';
        if (bar) bar.style.width = pct(tot);
      }
    });
  }
})();
